import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  class: "my-5",
  style: {"display":"flex","align-items":"center","justify-content":"space-between","gap":"1rem","flex-wrap":"wrap"}
}
const _hoisted_3 = {
  class: "font-semibold mt-4",
  style: {"margin":"0"}
}
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = {
  class: "widget shadow-100",
  style: {"height":"90px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_7 = { style: {"flex":"1","text-align":"center"} }
const _hoisted_8 = { class: "container-full-2" }
const _hoisted_9 = { class: "text-4xl font-bold" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = {
  class: "widget shadow-100",
  style: {"height":"90px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_12 = { style: {"flex":"1","text-align":"center"} }
const _hoisted_13 = { class: "container-full-2" }
const _hoisted_14 = { class: "text-4xl font-bold" }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = {
  class: "widget shadow-100",
  style: {"height":"90px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_17 = { style: {"flex":"1","text-align":"center"} }
const _hoisted_18 = { class: "container-full-2" }
const _hoisted_19 = { class: "text-4xl font-bold" }
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = {
  class: "widget shadow-100",
  style: {"height":"90px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_22 = { style: {"flex":"1","text-align":"center"} }
const _hoisted_23 = { class: "container-full-2" }
const _hoisted_24 = { class: "text-4xl font-bold" }
const _hoisted_25 = {
  class: "d-flex",
  style: {"height":"400px"}
}
const _hoisted_26 = { style: {"height":"100%","display":"flex","flex":"1 1 60%"} }
const _hoisted_27 = { class: "widget shadow-100 pb-2" }
const _hoisted_28 = { class: "container-full-2" }
const _hoisted_29 = { class: "chart-container" }
const _hoisted_30 = { class: "bar-chart-wrapper" }
const _hoisted_31 = { class: "bar-value" }
const _hoisted_32 = { class: "chart-labels" }
const _hoisted_33 = {
  class: "flex-1",
  style: {"height":"100%","display":"flex"}
}
const _hoisted_34 = { class: "widget shadow-100 pb-2" }
const _hoisted_35 = { class: "container-full-2" }
const _hoisted_36 = { class: "table separator skin1" }
const _hoisted_37 = {
  class: "d-flex",
  style: {"height":"400px"}
}
const _hoisted_38 = {
  class: "flex-1",
  style: {"height":"100%","display":"flex"}
}
const _hoisted_39 = { class: "widget shadow-100 pb-2" }
const _hoisted_40 = { class: "container-full-2" }
const _hoisted_41 = { class: "line-chart-container" }
const _hoisted_42 = {
  class: "line-chart",
  viewBox: "0 0 600 200",
  preserveAspectRatio: "none"
}
const _hoisted_43 = ["d"]
const _hoisted_44 = ["d"]
const _hoisted_45 = ["d"]
const _hoisted_46 = ["d"]
const _hoisted_47 = { class: "line-chart-labels" }
const _hoisted_48 = {
  class: "flex-1",
  style: {"height":"100%","display":"flex"}
}
const _hoisted_49 = { class: "widget shadow-100 pb-2" }
const _hoisted_50 = { class: "container-full-2" }
const _hoisted_51 = { class: "table separator skin1" }
const _hoisted_52 = { key: 0 }

import { ref, onMounted, computed } from 'vue'
import membersService from '@/services/membersService'
import authService from '@/services/authService'

interface Stats {
  totalMembres: number
  membresActifs: number
  encoursTotal: number
  retardsPaiement: number
}

interface MembreRecent {
  nom: string
  prenom: string
  dateInscription: string
}

interface MembreRetard {
  nom: string
  solde: number
  dateDernierPaiement: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesDashboard',
  setup(__props) {

const collectiviteId = ref<number | null>(null)
const collectiviteNom = ref<string>('')

const stats = ref<Stats>({
  totalMembres: 0,
  membresActifs: 0,
  encoursTotal: 0,
  retardsPaiement: 0
})

const souscriptionsSeries = ref({
  data: [230, 250, 280, 320, 310, 290, 340, 360, 400],
  categories: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep']
})

const remboursementSeries = ref({
  prevu: [20000, 24000, 26000, 28000, 30000, 32000],
  paye: [18000, 20000, 25000, 26000, 28000, 31000],
  categories: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun']
})

const membresRecents = ref<MembreRecent[]>([])

const membresRetards = ref<MembreRetard[]>([])

const maxSouscription = computed(() => {
  return Math.max(...souscriptionsSeries.value.data)
})

function formatNumber(num: number): string {
  return new Intl.NumberFormat('fr-FR').format(num)
}

function generateLinePath(data: number[], height: number): string {
  const max = Math.max(...data)
  const width = 600
  const step = width / (data.length - 1)
  
  let path = `M 0 ${height - (data[0] / max) * height}`
  for (let i = 1; i < data.length; i++) {
    const x = i * step
    const y = height - (data[i] / max) * height
    path += ` L ${x} ${y}`
  }
  
  return path
}

function generateAreaPath(data: number[], height: number): string {
  const max = Math.max(...data)
  const width = 600
  const step = width / (data.length - 1)
  
  let path = `M 0 ${height}`
  path += ` L 0 ${height - (data[0] / max) * height}`
  
  for (let i = 1; i < data.length; i++) {
    const x = i * step
    const y = height - (data[i] / max) * height
    path += ` L ${x} ${y}`
  }
  
  path += ` L ${width} ${height} Z`
  
  return path
}

async function loadStats() {
  try {
    // Récupérer l'utilisateur connecté
    const currentUser = authService.getCurrentUser()
    if (!currentUser) {
      console.error('Utilisateur non connecté')
      return
    }

    // Récupérer l'ID de la collectivité depuis les données utilisateur
    const userCollectiviteId = currentUser.collectivite_id || currentUser.collectivite?.id || null
    
    if (!userCollectiviteId) {
      console.warn('Aucune collectivité associée à l\'utilisateur')
      return
    }

    collectiviteId.value = userCollectiviteId
    collectiviteNom.value = currentUser.collectivite?.nom || 'Ma Collectivité'

    // Charger les membres de cette collectivité uniquement
    const membersData = await membersService.listMembers({ 
      pageNumber: 1,
      collectivite_id: String(userCollectiviteId)
    })
    
    if (membersData.total !== undefined) {
      stats.value.totalMembres = membersData.total
    }

    // Compter les membres actifs
    if (membersData.data) {
      stats.value.membresActifs = membersData.data.filter((m: any) => m.actif === 1 && !m.deleted_at).length
      
      // Récupérer les membres récents (5 derniers)
      membresRecents.value = membersData.data
        .filter((m: any) => !m.deleted_at)
        .sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
        .slice(0, 5)
        .map((m: any) => ({
          nom: m.nom,
          prenom: m.prenom,
          dateInscription: formatDate(m.created_at)
        }))
    }

    // TODO: Charger les autres statistiques depuis l'API quand les endpoints seront disponibles
    // Pour l'instant, on utilise des valeurs par défaut
    stats.value.encoursTotal = 183400000
    stats.value.retardsPaiement = 0

    // TODO: Charger les membres avec retards de paiement depuis l'API
    // membresRetards.value = await loadMembresRetards(userCollectiviteId)
    
  } catch (error) {
    console.error('Erreur lors du chargement des statistiques:', error)
  }
}

function formatDate(dateString?: string): string {
  if (!dateString) return '—'
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

onMounted(() => {
  loadStats()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "page-space-5" }, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, " Dashboard " + _toDisplayString(collectiviteNom.value ? collectiviteNom.value : 'Collectivité'), 1),
        _createVNode(_component_router_link, {
          to: "/front/collectivites/membres",
          class: "btn",
          style: {"white-space":"nowrap","color":"var(--color-white) !important"}
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: "/public/icons/icon-user.svg",
              class: "btn-icon icon-white",
              alt: ""
            }, null, -1),
            _createElementVNode("span", { style: {"color":"var(--color-white)","white-space":"nowrap"} }, "Gérer les membres", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-light" }, "Total Membres")
              ], -1)),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString(formatNumber(stats.value.totalMembres)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-light" }, "Membres actifs")
              ], -1)),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("div", _hoisted_14, _toDisplayString(formatNumber(stats.value.membresActifs)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-light" }, "Encours total")
              ], -1)),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("div", _hoisted_19, _toDisplayString(formatNumber(stats.value.encoursTotal)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-light" }, "Retards paiement")
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("div", _hoisted_24, _toDisplayString(stats.value.retardsPaiement), 1)
            ])
          ])
        ])
      ])
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("section", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_28, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-semibold mt-8" }, "Souscriptions par mois")
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(souscriptionsSeries.value.data, (value, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "bar-chart-item",
                      style: _normalizeStyle({ height: `${(value / maxSouscription.value) * 100}%` })
                    }, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(value), 1)
                    ], 4))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(souscriptionsSeries.value.categories, (label, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(label), 1))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_35, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-semibold mt-8" }, "Membres récents")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("table", _hoisted_36, [
                _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Nom & Prénoms"),
                    _createElementVNode("th", null, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-filter-down.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }),
                      _createTextVNode(" Date inscription ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membresRecents.value, (membre, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(membre.nom) + " " + _toDisplayString(membre.prenom), 1),
                      _createElementVNode("td", null, _toDisplayString(membre.dateInscription), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("section", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_40, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-semibold mt-8" }, "Courbe des remboursements (Prévu vs Payé)")
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(), _createElementBlock("svg", _hoisted_42, [
                  _cache[15] || (_cache[15] = _createStaticVNode("<defs data-v-555d8af4><linearGradient id=\"gradientPrevu\" x1=\"0%\" y1=\"0%\" x2=\"0%\" y2=\"100%\" data-v-555d8af4><stop offset=\"0%\" style=\"stop-color:#2563EB;stop-opacity:0.3;\" data-v-555d8af4></stop><stop offset=\"100%\" style=\"stop-color:#2563EB;stop-opacity:0;\" data-v-555d8af4></stop></linearGradient><linearGradient id=\"gradientPaye\" x1=\"0%\" y1=\"0%\" x2=\"0%\" y2=\"100%\" data-v-555d8af4><stop offset=\"0%\" style=\"stop-color:#10B981;stop-opacity:0.3;\" data-v-555d8af4></stop><stop offset=\"100%\" style=\"stop-color:#10B981;stop-opacity:0;\" data-v-555d8af4></stop></linearGradient></defs>", 1)),
                  _createElementVNode("path", {
                    d: generateAreaPath(remboursementSeries.value.prevu, 200),
                    fill: "url(#gradientPrevu)",
                    stroke: "#2563EB",
                    "stroke-width": "2",
                    "fill-opacity": "0.3"
                  }, null, 8, _hoisted_43),
                  _createElementVNode("path", {
                    d: generateAreaPath(remboursementSeries.value.paye, 200),
                    fill: "url(#gradientPaye)",
                    stroke: "#10B981",
                    "stroke-width": "2",
                    "fill-opacity": "0.3"
                  }, null, 8, _hoisted_44),
                  _createElementVNode("path", {
                    d: generateLinePath(remboursementSeries.value.prevu, 200),
                    fill: "none",
                    stroke: "#2563EB",
                    "stroke-width": "2"
                  }, null, 8, _hoisted_45),
                  _createElementVNode("path", {
                    d: generateLinePath(remboursementSeries.value.paye, 200),
                    fill: "none",
                    stroke: "#10B981",
                    "stroke-width": "2"
                  }, null, 8, _hoisted_46)
                ])),
                _createElementVNode("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remboursementSeries.value.categories, (label, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(label), 1))
                  }), 128))
                ]),
                _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"line-chart-legend\" data-v-555d8af4><div class=\"legend-item\" data-v-555d8af4><span class=\"legend-color\" style=\"background-color:#2563EB;\" data-v-555d8af4></span><span data-v-555d8af4>Prévu</span></div><div class=\"legend-item\" data-v-555d8af4><span class=\"legend-color\" style=\"background-color:#10B981;\" data-v-555d8af4></span><span data-v-555d8af4>Payé</span></div></div>", 1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_50, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "s20" }, [
                _createElementVNode("h4", { class: "font-semibold mt-8" }, "Membres avec retards de paiement")
              ], -1)),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
              _createElementVNode("table", _hoisted_51, [
                _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Nom & Prénoms"),
                    _createElementVNode("th", null, "Solde"),
                    _createElementVNode("th", null, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-filter-down.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }),
                      _createTextVNode(" Date Dernier Paiement ")
                    ])
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (membresRetards.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [...(_cache[19] || (_cache[19] = [
                        _createElementVNode("td", {
                          colspan: "3",
                          class: "text-center text-grey-600"
                        }, "Aucun retard de paiement", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membresRetards.value, (membre, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(membre.nom), 1),
                      _createElementVNode("td", null, _toDisplayString(formatNumber(membre.solde)), 1),
                      _createElementVNode("td", null, _toDisplayString(membre.dateDernierPaiement), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1))
  ]))
}
}

})